import AspectDiv from "@/components/AspectDiv";
import { Image03Icon } from "@/icons";
import { cn } from "@/utils/tailwind";
import { useIntl } from "react-intl";

const RATIO = 4.75;

interface ActivityBannerProps {
  title: string;
  banner?: string | null;
}

export function ActivityBanner({
  title,
  banner,
}: Readonly<ActivityBannerProps>) {
  const intl = useIntl();
  return (
    <AspectDiv
      className={cn(
        "overflow-hidden relative rounded-xl",
        !banner && "bg-grey-50",
      )}
      ratio={RATIO}
    >
      {banner ? (
        <img
          src={banner}
          className="w-full h-full rounded-xl object-cover object-center"
          alt={intl.formatMessage(
            { defaultMessage: "{title} background cover" },
            { title },
          )}
        />
      ) : (
        <div className="w-full h-full flex flex-col justify-center items-center">
          <div className="flex justify-center items-center w-14 h-14 bg-white rounded-full shadow-[0px_24px_48px_-12px_rgba(16,24,40,0.18)]">
            <Image03Icon className="text-brand-400 w-8 h-8" />
          </div>
        </div>
      )}
    </AspectDiv>
  );
}
